import { useState } from 'react';
import toast from 'react-hot-toast';
import { useAuth } from '../contexts/AuthContext';
import { usersAPI } from '../utils/api';
import PasswordRequirements, { isPasswordValid, passwordError } from './PasswordRequirements';

export default function RequiredPasswordChange() {
  const { user, logout, stopImpersonation } = useAuth();
  const [current, setCurrent] = useState('');
  const [password, setPassword] = useState('');
  const [confirmation, setConfirmation] = useState('');
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);
  return <main className="min-h-screen bg-gray-50 flex items-center justify-center p-6">
    <form className="bg-white rounded-lg shadow p-6 max-w-md w-full space-y-4" onSubmit={async event => {
      event.preventDefault();
      if (!user || !isPasswordValid(password) || password !== confirmation) return;
      setSaving(true); setError('');
      try {
        await usersAPI.changePassword(user.id, { current_password: current, new_password: password });
        await logout();
        toast.success('Password aggiornata. Accedi con la nuova password.');
      } catch (err) { setError(passwordError(err)); } finally { setSaving(false); }
    }}>
      <h1 className="text-xl font-semibold">Scegli la tua password</h1>
      <p>La password assegnata è temporanea. Prima di continuare devi sostituirla.</p>
      <label className="block">Password temporanea<input className="block border rounded p-2 w-full" type="password" autoComplete="current-password" required value={current} onChange={e => setCurrent(e.target.value)} /></label>
      <label className="block">Nuova password<input className="block border rounded p-2 w-full" type="password" autoComplete="new-password" required value={password} onChange={e => setPassword(e.target.value)} /></label>
      <PasswordRequirements password={password} />
      <label className="block">Conferma nuova password<input className="block border rounded p-2 w-full" type="password" autoComplete="new-password" required value={confirmation} onChange={e => setConfirmation(e.target.value)} /></label>
      {confirmation && confirmation !== password && <p role="alert">Le password non coincidono</p>}
      {error && <p role="alert" className="text-red-700">{error}</p>}
      <button className="bg-blue-600 text-white px-4 py-2 rounded disabled:opacity-50" disabled={saving || !current || !isPasswordValid(password) || password !== confirmation}>Salva e accedi di nuovo</button>
      {user?.impersonating && <button type="button" className="ml-3" onClick={stopImpersonation}>Torna alla mia sessione</button>}
      <button type="button" className="ml-3" onClick={logout}>Esci</button>
    </form>
  </main>;
}
